import { Dispatch, SetStateAction, useCallback, useState } from 'react'
import { IColumnSetting, IGetUserSettingPayload, IPostUserSettingPayload } from '../models/user.model'
import { getUserSetting, updateUserSetting } from '../services/UserSettingService'

export interface IUserSettingHook {
  userSetting: Array<IColumnSetting>
  isGettingSetting: boolean
  isUpdatingSetting: boolean
  setUserSetting: Dispatch<SetStateAction<Array<IColumnSetting>>>
  getSetting: (payload: IGetUserSettingPayload) => Promise<Array<IColumnSetting>>
  updateSetting: (payload: IPostUserSettingPayload) => Promise<void>
}

export const useUserSetting = (): IUserSettingHook => {
  const [userSetting, setUserSetting] = useState<Array<IColumnSetting>>([])
  const [isGettingSetting, setIsGettingSetting] = useState<boolean>(false)
  const [isUpdatingSetting, setIsUpdatingSetting] = useState<boolean>(false)

  const getSetting = useCallback(async (payload: IGetUserSettingPayload) => {
    try {
      setIsGettingSetting(true)
      const data = await getUserSetting(payload)
      if (data.data && data.data.length > 0) {
        setUserSetting(data.data)
      }
      return data.data
    } catch (error) {
      console.log('ERROR: ', error)
      return []
    } finally {
      setIsGettingSetting(false)
    }
  }, [])

  const updateSetting = useCallback(async (payload: IPostUserSettingPayload) => {
    try {
      setIsUpdatingSetting(true)
      const data = await updateUserSetting(payload)
      if (data.data && data.data.length > 0) {
        setUserSetting(data.data)
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setIsUpdatingSetting(false)
    }
  }, [])

  return {
    userSetting,
    isUpdatingSetting,
    isGettingSetting,
    setUserSetting,
    getSetting,
    updateSetting,
  }
}
